import React, { useEffect, useState } from 'react';
import comma from '../Assets/66b9ff80d242858b70d662e9_Vector.svg.png';
import { Get_Api } from '../Api_Url';

function AllReviews() {
    const [isUploading, setIsUploading] = useState(false);
    const [reviews, setReviews] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFading, setIsFading] = useState(false);

    const getReviews = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api(`api/admin/GetAllReviews`);
            setReviews(response?.data || []);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        getReviews();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsFading(true);
            setTimeout(() => {
                setCurrentIndex((prev) => (prev + 1) % reviews.length);
                setIsFading(false);
            }, 800);
        }, 5000);

        return () => clearInterval(interval);
    }, [reviews.length]);

    return (
        <div className='review-container'>
            {isUploading ? (
                <p>Loading...</p>
            ) : reviews.length > 0 ? (
                <div className={`review-row ${isFading ? 'fade' : 'show'}`}>
                    {[0, 1].map((offset) => (
                        <div key={offset} className='review-box'>
                            <img src={comma} alt='quote' />
                            <h3>{reviews[(currentIndex + offset) % reviews.length]?.Description}</h3>
                            <p>{reviews[(currentIndex + offset) % reviews.length]?.UserName}</p>
                        </div>
                    ))}
                </div>
            ) : (
                <p>No reviews found</p>
            )}
        </div>
    );
}

export default AllReviews;
